module.exports = __webpack_public_path__ + "static/media/69.8a970a9b.png";